/* eslint-disable max-len */
import ImageTobi from '../assets/step-plans/img_tobi.png';
import { PLANS } from '../utils/constants/plans';

export const AUDITORY_MODEL = {
  paso: 1,
  pasoDescripcion: 'PASO_PLANES',
};

export const rbrPlansModel = {
  title: '¡Hola, {name}!',
  description: 'Selecciona el plan que se adapta a lo que necesitas:',
  disclaimer: 'Los precios de cada plan están calculados de acuerdo a tu edad',
  plans: [
    {
      idePlanSAS: null,
      codPlan: PLANS.COD_PLAN_BASICO,
      nroPlanRS: Number(PLANS.NRO_PLAN_RS_BASICO),
      name: 'Plan Básico',
      price: 60,
      currency: 'S/',
      period: 'mensual',
      description: 'Atención en Clínica Internacional, Javier Prado, Good Hope, entre otras.',
      showClinics: true,
      isRecommend: false,
      coverages: [
        {
          name: 'Emergencias accidentales',
          description: 'Cubiertas al 100%',
        },
      ],
      completeCoverages: [
        {
          id: 1,
          icon: 'RideGlHospitalAttentionSolid',
          description: 'Chequeo preventivo anual sin costo',
        },
      ],
      mainCoveragesIds: [1, 2, 3, 4, 5, 6, 7],
      additionalCoveragesIds: [1],
      benefits: [
        {
          name: 'Médico a domicilio',
          description: 'Consulta a S/45, más medicinas y exámenes al 100%',
        },
        {
          name: 'Centro Médico Virtual',
          description: 'sin costo',
        },
        {
          name: 'Atención en clínicas',
          description: 'Consulta a S/45, más medicinas y exámenes al 70%',
        },
      ],
    },
    {
      idePlanSAS: null,
      codPlan: PLANS.COD_PLAN_ESTANDAR,
      nroPlanRS: Number(PLANS.NRO_PLAN_RS_ESTANDAR),
      name: 'Plan Estándar',
      price: 134,
      currency: 'S/',
      period: 'mensual',
      description: 'Atención en Clínica Internacional, Javier Prado, Good Hope, entre otras.',
      showClinics: true,
      isRecommend: false,
      coverages: [
        {
          name: 'Emergencias accidentales',
          description: 'Cubiertas al 100%',
        },
        {
          name: 'Hospitalización y maternidad',
          description: 'Cubiertas al 70%',
        },
      ],
      mainCoveragesIds: [1, 2, 3, 4, 5, 6, 7],
      additionalCoveragesIds: [1, 2],
      completeCoverages: [
        {
          id: 2,
          icon: 'RideGlAmbulanceSolid',
          description: 'Emergencias y ambulancias',
        },
      ],
      benefits: [
        {
          name: 'Médico a domicilio',
          description: 'Consulta a S/45, más medicinas y exámenes al 100%',
        },
        {
          name: 'Centro Médico Virtual',
          description: 'sin costo',
        },
        {
          name: 'Atención en clínicas',
          description: 'Consulta a S/45, más medicinas y exámenes al 70%',
        },
      ],
    },
    {
      idePlanSAS: null,
      codPlan: PLANS.COD_PLAN_COMPLETO,
      nroPlanRS: Number(PLANS.NRO_PLAN_RS_COMPLETO),
      name: 'Plan Completo',
      price: 166,
      currency: 'S/',
      period: 'mensual',
      description: 'Atención en Clínica Internacional, Javier Prado, Good Hope, entre otras.',
      showClinics: true,
      isRecommend: true,
      coverages: [
        {
          name: 'Emergencias accidentales',
          description: 'Cubiertas al 100%',
        },
        {
          name: 'Hospitalización y maternidad',
          description: 'Cubiertas al 70%',
        },
        {
          name: 'Odontología y oftalmología',
          description: 'Cubiertas al 70%',
        },
      ],
      mainCoveragesIds: [1, 2, 3, 4, 5, 6, 7],
      additionalCoveragesIds: [1, 2, 3],
      completeCoverages: [
        {
          id: 2,
          icon: 'RideGlAmbulanceSolid',
          description: 'Emergencias y ambulancias',
        },
        {
          id: 3,
          icon: 'RideGlHospitalizationSolid',
          description: 'Hospitalización y maternidad',
        },
      ],
      benefits: [
        {
          name: 'Médico a domicilio',
          description: 'Consulta a S/45, más medicinas y exámenes al 100%',
        },
        {
          name: 'Centro Médico Virtual',
          description: 'sin costo',
        },
        {
          name: 'Atención en clínicas',
          description: 'Consulta a S/45, más medicinas y exámenes al 70%',
        },
      ],
    },
    {
      nroPlanRS: Number(PLANS.NRO_PLAN_RS_PLUS),
      idePlanSAS: null,
      codPlan: PLANS.COD_PLAN_PLUS,
      name: 'Plan Plus',
      price: 186,
      currency: 'S/',
      period: 'mensual',
      description: 'Atención en Clínica Internacional, Javier Prado, Good Hope, entre otras.',
      showClinics: true,
      isRecommend: false,
      coverages: [
        {
          name: 'Emergencias accidentales',
          description: 'Cubiertas al 100%',
        },
        {
          name: 'Hospitalización y maternidad',
          description: 'Cubiertas al 70%',
        },
        {
          name: 'Chequeo preventivo anual',
          description: 'Sin costo',
        },
        {
          name: 'Odontología y oftalmología',
          description: 'Cubiertas al 70%',
        },
      ],
      mainCoveragesIds: [1, 2, 3, 4, 5, 6, 7],
      additionalCoveragesIds: [1, 2, 3, 4],
      completeCoverages: [
        {
          id: 2,
          icon: 'RideGlAmbulanceSolid',
          description: 'Emergencias y ambulancias',
        },
        {
          id: 3,
          icon: 'RideGlHospitalizationSolid',
          description: 'Hospitalización y maternidad',
        },
        {
          id: 4,
          icon: 'RideGlDentistSolid',
          description: 'Odontología y oftalmología',
        },
        {
          id: 1,
          icon: 'RideGlHospitalAttentionSolid',
          description: 'Chequeo preventivo anual sin costo',
        },
      ],
      benefits: [
        {
          name: 'Médico a domicilio',
          description: 'Consulta a S/45, más medicinas y exámenes al 100%',
        },
        {
          name: 'Centro Médico Virtual',
          description: 'sin costo',
        },
        {
          name: 'Atención en clínicas',
          description: 'Consulta a S/45, más medicinas y exámenes al 70%',
        },
      ],
    },
  ],
};

export const rbrContactModel = {
  title: '¿Te gustaría personalizar tu plan de salud?',
  description: 'Si deseas personalizar tu plan ponte en contacto con un experto RIMAC para que te asesore por teléfono.',
  telephone: '(01) 411 6001',
  image: ImageTobi,
};

export const detailPlanModel = {
  title: 'Te contamos más sobre tus coberturas',
  plans: [
    {
      name: 'Plan Básico',
      coverages: [
        {
          icon: 'RideGlMedicalAttentionOutline',
          name: 'Medico a domicilio',
          content: 'En medicina general y pediatría por S/45 + medicinas cubiertas al 100% y toma de muestra de laboratorio a domicilio (solo para enfermedades de baja complejidad)',
        },
        {
          icon: 'RideGlHospitalOutline',
          name: 'Atención en clínica',
          content: 'Accede a consultas médicas de manera presencial por S/45, en cualquier especialidad y en toda la red de clínicas que forman parte de tu plan. La cobertura tiene alcance para las medicinas recetadas y para los exámenes derivados al 70%.',
        },
        {
          icon: 'RideGlAmbulanceOutline',
          name: 'Emergencias accidentales',
          content: 'Accidentales</br>Las emergencias ocurridas por accidente y las Emergencias médicas deben ser asistidas dentro de las primeras 48 horas. No existe continuación de emergencia accidental pasada las 48 horas. Por ejemplo: fractura, choque o quemadura*.</br></br>Gastos ambulatorios: Los gastos ambulatorios de las emergencias ocurridas por accidentes son cubiertas al 100%</br>Gastos hospitalarios: Los gastos hospitalarios de las emergencias ocurridas por accidentes son cubierta al 70%.</br></br>No Accidentales</br>Gastos ambulatorios y hospitalarios: Los gastos ambulatorios y hospitalarios de las emergencias no accidentales son cubierta al 70%.</br>Por ejemplo: infarto, apendicitis, etc*.</br></br>*La determinación de la condición de emergencia es realizada por el profesional médico encargado de la atención bajo responsabilidad.',
        },
      ],
      othersCoverages: [
        {
          icon: 'RideGlLaptopOutline',
          name: 'Centro Médico Virtual',
          content: 'En medicina general y pediatría gratis + medicinas cubiertas al 100% (solo para enfermedades de baja complejidad)',
        },
        {
          icon: 'RideGlCoinsOutline',
          name: 'Indemnización Hospitalaria',
          content: 'Te indemnizamos por S/300 por día de hospitalización a causa de una enfermedad o accidente. Máximo hasta 30 días de hospitalización.',
        },
      ],
      doesNotCover: {
        title: 'Lo que no cubre',
        content: '<ul><li>Trastornos o problemas de aprendizaje o lenguaje.</li><li>Afectaciones o lesiones por uso de drogas, fármacos o alcohol no diagnosticadas por un médico.</li><li>Embarazo, maternidad, sus complicaciones y consecuencias cuando no se ha comprado la cobertura adicional de Hospitalización y maternidad.</li><li>Consecuencias de negligencia en su rehabilitación y automedicación.</li></ul></br>Podrás ver el listado completo en la póliza de tu seguro.',
      },
    },
    {
      name: 'Plan Estándar',
      coverages: [
        {
          icon: 'RideGlMedicalAttentionOutline',
          name: 'Medico a domicilio',
          content: 'En medicina general y pediatría por S/45 + medicinas cubiertas al 100% y toma de muestra de laboratorio a domicilio (solo para enfermedades de baja complejidad)',
        },
        {
          icon: 'RideGlHospitalOutline',
          name: 'Atención en clínica',
          content: 'Accede a consultas médicas de manera presencial por S/45, en cualquier especialidad y en toda la red de clínicas que forman parte de tu plan. La cobertura tiene alcance para las medicinas recetadas y para los exámenes derivados al 70%.',
        },
        {
          icon: 'RideGlAmbulanceOutline',
          name: 'Emergencias accidentales',
          content: 'Accidentales</br>Las emergencias ocurridas por accidente y las Emergencias médicas deben ser asistidas dentro de las primeras 48 horas. No existe continuación de emergencia accidental pasada las 48 horas. Por ejemplo: fractura, choque o quemadura*.</br></br>Gastos ambulatorios: Los gastos ambulatorios de las emergencias ocurridas por accidentes son cubiertas al 100%</br>Gastos hospitalarios: Los gastos hospitalarios de las emergencias ocurridas por accidentes son cubierta al 70%.</br></br>No Accidentales</br>Gastos ambulatorios y hospitalarios: Los gastos ambulatorios y hospitalarios de las emergencias no accidentales son cubierta al 70%.</br>Por ejemplo: infarto, apendicitis, etc*.</br></br>*La determinación de la condición de emergencia es realizada por el profesional médico encargado de la atención bajo responsabilidad.',
        },
        {
          icon: 'RideGlHospitalizationOutline',
          name: 'Hospitalización y maternidad',
          content: 'Cobertura de atenciones hospitalarias a S/45 cubiertas al 70%, incluye las cirugías, atenciones hospitalarias por tratamiento médico, los honorarios de los médicos tratantes y más.',
        },
      ],
      othersCoverages: [
        {
          icon: 'RideGlLaptopOutline',
          name: 'Centro Médico Virtual',
          content: 'En medicina general y pediatría gratis + medicinas cubiertas al 100% (solo para enfermedades de baja complejidad)',
        },
        {
          icon: 'RideGlCoinsOutline',
          name: 'Indemnización Hospitalaria',
          content: 'Te indemnizamos por S/300 por día de hospitalización a causa de una enfermedad o accidente. Máximo hasta 30 días de hospitalización.',
        },
      ],
      doesNotCover: {
        title: 'Lo que no cubre',
        content: '<ul><li>Trastornos o problemas de aprendizaje o lenguaje.</li><li>Afectaciones o lesiones por uso de drogas, fármacos o alcohol no diagnosticadas por un médico.</li><li>Embarazo, maternidad, sus complicaciones y consecuencias cuando no se ha comprado la cobertura adicional de Hospitalización y maternidad.</li><li>Consecuencias de negligencia en su rehabilitación y automedicación.</li></ul></br>Podrás ver el listado completo en la póliza de tu seguro.',
      },
    },
    {
      name: 'Plan Completo',
      coverages: [
        {
          icon: 'RideGlMedicalAttentionOutline',
          name: 'Medico a domicilio',
          content: 'En medicina general y pediatría por S/45 + medicinas cubiertas al 100% y toma de muestra de laboratorio a domicilio (solo para enfermedades de baja complejidad)',
        },
        {
          icon: 'RideGlHospitalOutline',
          name: 'Atención en clínica',
          content: 'Accede a consultas médicas de manera presencial por S/45, en cualquier especialidad y en toda la red de clínicas que forman parte de tu plan. La cobertura tiene alcance para las medicinas recetadas y para los exámenes derivados al 70%.',
        },
        {
          icon: 'RideGlAmbulanceOutline',
          name: 'Emergencias accidentales',
          content: 'Accidentales</br>Las emergencias ocurridas por accidente y las Emergencias médicas deben ser asistidas dentro de las primeras 48 horas. No existe continuación de emergencia accidental pasada las 48 horas. Por ejemplo: fractura, choque o quemadura*.</br></br>Gastos ambulatorios: Los gastos ambulatorios de las emergencias ocurridas por accidentes son cubiertas al 100%</br>Gastos hospitalarios: Los gastos hospitalarios de las emergencias ocurridas por accidentes son cubierta al 70%.</br></br>No Accidentales</br>Gastos ambulatorios y hospitalarios: Los gastos ambulatorios y hospitalarios de las emergencias no accidentales son cubierta al 70%.</br>Por ejemplo: infarto, apendicitis, etc*.</br></br>*La determinación de la condición de emergencia es realizada por el profesional médico encargado de la atención bajo responsabilidad.',
        },
        {
          icon: 'RideGlHospitalizationOutline',
          name: 'Hospitalización y maternidad',
          content: 'Cobertura de atenciones hospitalarias a S/45 cubiertas al 70%, incluye las cirugías, atenciones hospitalarias por tratamiento médico, los honorarios de los médicos tratantes y más.',
        },
        {
          icon: 'RideGlDentistOutline',
          name: 'Odontología y Oftalmología',
          content: 'Oftalmología: Consultas a S/45 en centros especializados, incluye medicinas y exámenes derivados cubiertos al 70%. Consultas a S/45 por pieza tratada y terminada en centros especializado cubiertas al 70%. Incluye examen oral inicial, radiografías. profilaxis general, fluor y sellantes (hasta los 12 años), restauraciones: resinas (piezas anteriores y posteriores), resina con luz alógena, terapia radicular (endodoncia), pulpectomía, apiceptomía y extracciones.',
        },
      ],
      othersCoverages: [
        {
          icon: 'RideGlLaptopOutline',
          name: 'Centro Médico Virtual',
          content: 'En medicina general y pediatría gratis + medicinas cubiertas al 100% (solo para enfermedades de baja complejidad)',
        },
        {
          icon: 'RideGlCoinsOutline',
          name: 'Indemnización Hospitalaria',
          content: 'Te indemnizamos por S/300 por día de hospitalización a causa de una enfermedad o accidente. Máximo hasta 30 días de hospitalización.',
        },
      ],
      doesNotCover: {
        title: 'Lo que no cubre',
        content: '<ul><li>Trastornos o problemas de aprendizaje o lenguaje.</li><li>Afectaciones o lesiones por uso de drogas, fármacos o alcohol no diagnosticadas por un médico.</li><li>Embarazo, maternidad, sus complicaciones y consecuencias cuando no se ha comprado la cobertura adicional de Hospitalización y maternidad.</li><li>Consecuencias de negligencia en su rehabilitación y automedicación.</li></ul></ul></br>Podrás ver el listado completo en la póliza de tu seguro.',
      },
    },
    {
      name: 'Plan Plus',
      coverages: [
        {
          icon: 'RideGlMedicalAttentionOutline',
          name: 'Medico a domicilio',
          content: 'En medicina general y pediatría por S/45 + medicinas cubiertas al 100% y toma de muestra de laboratorio a domicilio (solo para enfermedades de baja complejidad)',
        },
        {
          icon: 'RideGlHospitalOutline',
          name: 'Atención en clínica',
          content: 'Accede a consultas médicas de manera presencial por S/45, en cualquier especialidad y en toda la red de clínicas que forman parte de tu plan. La cobertura tiene alcance para las medicinas recetadas y para los exámenes derivados al 70%.',
        },
        {
          icon: 'RideGlAmbulanceOutline',
          name: 'Emergencias accidentales',
          content: 'Accidentales</br>Las emergencias ocurridas por accidente y las Emergencias médicas deben ser asistidas dentro de las primeras 48 horas. No existe continuación de emergencia accidental pasada las 48 horas. Por ejemplo: fractura, choque o quemadura*.</br></br>Gastos ambulatorios: Los gastos ambulatorios de las emergencias ocurridas por accidentes son cubiertas al 100%</br>Gastos hospitalarios: Los gastos hospitalarios de las emergencias ocurridas por accidentes son cubierta al 70%.</br></br>No Accidentales</br>Gastos ambulatorios y hospitalarios: Los gastos ambulatorios y hospitalarios de las emergencias no accidentales son cubierta al 70%.</br>Por ejemplo: infarto, apendicitis, etc*.</br></br>*La determinación de la condición de emergencia es realizada por el profesional médico encargado de la atención bajo responsabilidad.',
        },
        {
          icon: 'RideGlHospitalizationOutline',
          name: 'Hospitalización y maternidad',
          content: 'Cobertura de atenciones hospitalarias a S/45 cubiertas al 70%, incluye las cirugías, atenciones hospitalarias por tratamiento médico, los honorarios de los médicos tratantes y más.',
        },
        {
          icon: 'RideGlDentistOutline',
          name: 'Odontología y Oftalmología',
          content: 'Oftalmología: Consultas a S/45 en centros especializados, incluye medicinas y exámenes derivados cubiertos al 70%. Consultas a S/45 por pieza tratada y terminada en centros especializado cubiertas al 70%. Incluye examen oral inicial, radiografías. profilaxis general, fluor y sellantes (hasta los 12 años), restauraciones: resinas (piezas anteriores y posteriores), resina con luz alógena, terapia radicular (endodoncia), pulpectomía, apiceptomía y extracciones.',
        },
        {
          icon: 'RideGlHospitalAttentionOutline',
          name: 'Chequeo preventivo anual',
          content: 'Previene alguna enfermedad realizando tu chequeo preventivo anual sin costo de manera presencial o virtual en diversas especialidades. Algunas evaluaciones:<ul><li>Examen clínico</li><li>Análisis completo de orina</li><li>Análisis de sangre y heces</li><li>Evaluación odontológica</li><li>Evaluación oftalmológica</li><li>Evaluación cardiológica</li><li>Evaluación nutricional</li><li>Colonoscopia (de 40 a 75 años)</li></ul>Para <b>mujeres</b>, también se realiza:</br><ul><li>Examen ginecológico y papanicolau</li><li>Mamografía</li></ul><br/>*Varía dependiendo la clínica.',
        },
      ],
      othersCoverages: [
        {
          icon: 'RideGlLaptopOutline',
          name: 'Centro Médico Virtual',
          content: 'En medicina general y pediatría gratis + medicinas cubiertas al 100% (solo para enfermedades de baja complejidad)',
        },
        {
          icon: 'RideGlCoinsOutline',
          name: 'Indemnización Hospitalaria',
          content: 'Te indemnizamos por S/300 por día de hospitalización a causa de una enfermedad o accidente. Máximo hasta 30 días de hospitalización.',
        },
      ],
      doesNotCover: {
        title: 'Lo que no cubre',
        content: '<ul><li>Trastornos o problemas de aprendizaje o lenguaje.</li><li>Afectaciones o lesiones por uso de drogas, fármacos o alcohol no diagnosticadas por un médico.</li><li>Embarazo, maternidad, sus complicaciones y consecuencias cuando no se ha comprado la cobertura adicional de Hospitalización y maternidad.</li><li>Consecuencias de negligencia en su rehabilitación y automedicación.</li></ul></ul></br>Podrás ver el listado completo en la póliza de tu seguro.',
      },
    },
  ],
};
